import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { FontEmphasis } from '@prisjakt/ui/text';
import { ShippingCollection, StockStatus } from 'src/types';
import {
  ShippingType,
  isStockStatusSupported,
  getShippingDays,
  getStandardizedDeliveryText,
} from './utils';
import { usePriceRowContext } from '../../../price-row-context';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { Wrapper, CaptionText } from './styles';

interface IDeliveryTimeProps {
  shipping?: ShippingCollection | null;
  stockStatus?: StockStatus | null;
}

export const DeliveryTime: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IDeliveryTimeProps>
>> = props => {
  const { shipping, stockStatus } = props;
  const { t } = useContext(AppContext);
  const { forceMobileView } = usePriceRowContext();
  const label =
    stockStatus === 'in_stock' || stockStatus === 'incoming'
      ? `${t('product', 'delivery-time.label')}: `
      : '';
  const shippingDays = getShippingDays(t, ShippingType.CHEAPEST, shipping);
  const standardizedDeliveryText = getStandardizedDeliveryText(t, stockStatus);
  const deliveryTimeShort = isStockStatusSupported(stockStatus) && shippingDays;
  const deliveryTimeLong =
    label + (deliveryTimeShort ? shippingDays : standardizedDeliveryText);

  if (!shippingDays && !standardizedDeliveryText) {
    return null;
  }

  return (
    <Wrapper>
      <CaptionText emphasis={FontEmphasis.MEDIUM}>
        <MobileOnly>
          <span>{deliveryTimeShort}</span>
        </MobileOnly>
        {!forceMobileView && (
          <MediumUp>
            <span>{deliveryTimeLong}</span>
          </MediumUp>
        )}
      </CaptionText>
    </Wrapper>
  );
};
